import * as types from './types';

export const saveCurrentAudioSrc = (data) => (dispatch) =>
	dispatch({
		type: types.SAVE_CURRENT_AUDIO_SRC,
		payload: data
	});
